<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteClassSubjectDialog"
    :title="$t('subjects.deleteTitle')"
    :message="`${$t('subjects.deleteMessage')} '${subjectName}'؟`"
    :confirm-text="$t('subjects.deleteConfirm')"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p class="text-danger">{{ $t('subjects.deleteWarning') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const baseDialog = ref(null);
const subjectName = ref('');
const subjectId = ref(null);

const open = (subject) => {
  subjectName.value = subject.subject?.name || t('subjects.defaultName');
  subjectId.value = subject.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = () => {
  emit('delete', subjectId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
